import { useMutation } from '@apollo/client';
// Api
import { INIT_INSTAGRAM_AUTH } from 'api/auth/mutations';
// Api Types
// Types
import {
  InitInstagramAuth,
  InitInstagramAuthVariables,
} from 'api/auth/types/InitInstagramAuth';

export const useInitInstagramAuth = () => {
  return useMutation<InitInstagramAuth, InitInstagramAuthVariables>(
    INIT_INSTAGRAM_AUTH
  );
};
